export function PushSiteImproveEvent(action: string, label?: string) {
	if ((window as any)._sz)
		(window as any)._sz.push(["event", "raskAvklaring", action, label]);
}